import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ServiceItem } from "@/services/entities/ServiceItem";
import { reactive } from "vue";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";
import { useSettingsStore } from "@/stores/setting";
import ServiceForm from "@/components/services/ServiceForm.vue";
import { showToastError } from "@/toastification";
import { formatText } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateServiceModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const settingsStore = useSettingsStore();
const emit = __emit;

const state = reactive({
  value: {} as ServiceItem
});

const mandatoryFields = ["blServiceName", "blpgCode", "poNumber", "mxSalesOrder", "invoiceAddress", "sapNumber", "operationsManager", "orderValue", "divisionId", "countryId", "validFrom", "validTo"];

async function create() {
  let canCreate = true;
  mandatoryFields.forEach(element => {
    const value = state.value[element];
    if (value == null || value.length == 0) {
      showToastError(`Missing value: ${formatText(element)}`);
      canCreate = false;
    }
  });
  if (canCreate) {
    await settingsStore.createService(state.value);
    emit("close");
  }
}

function beforeClose() {
  vfm.open(confirmModalId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(ServiceForm, {
        value: state.value
      }, {
        header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "title" }, "Create service", -1)
        ]))]),
        buttons: _withCtx(() => [
          _createElementVNode("button", { onClick: beforeClose }, "Cancel"),
          _createElementVNode("button", {
            class: "accent",
            onClick: create
          }, "Create service")
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[0] || (_cache[0] = () => {
        _unref(vfm).close(_unref(confirmModalId));
        emit('close');
      }
        ),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})